import * as Factory from 'factory.ts'
import faker from 'faker'

import {
  type ApprovedExpenseItemAccountApiModel,
  type ApprovedExpenseItemApiModel,
} from '../ApprovedExpenseItemApiModel'

export const ApprovedExpenseItemAccountApiModelStub =
  Factory.Sync.makeFactory<ApprovedExpenseItemAccountApiModel>({
    id: Factory.each(() => faker.random.number()),
    account_code: Factory.each(() => ({
      id: faker.random.number(),
      code: faker.random.alphaNumeric(4).toUpperCase(),
      code_length: 4,
      description: faker.commerce.productName(),
      account_type: 2,
      account_type_display: 'Expense',
      active: true,
      parent: null,
    })),
    department: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.commerce.department(),
      active: true,
      branch: {
        id: faker.random.number(),
        name: faker.company.companyName(),
        headquarter: true,
      },
    })),
    start_datetime: Factory.each(() => faker.date.past().toISOString()),
    end_datetime: Factory.each(() => faker.date.future().toISOString()),
    budget: Factory.each(() => faker.finance.amount()),
    active: true,
  })

export const ApprovedExpenseItemApiModelStub =
  Factory.Sync.makeFactory<ApprovedExpenseItemApiModel>({
    id: Factory.each(() => faker.random.number()),
    line_num: Factory.each(() => faker.random.number({ min: 1, max: 9 })),
    merchant: Factory.each(() => faker.company.companyName()),
    amount: '466.31',
    expense_type: 5,
    expense_type_fields: {
      LODGING: { name: 'Lodging', key: 5, icon: 'icon-lodge' },
    },
    attachment: null,
    notes: null,
    approved_datetime: Factory.each(() => faker.date.past().toISOString()),
    localCurrency: 1,
    user: Factory.each(() => ({
      id: faker.random.number(),
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
      email: faker.internet.email(),
      position: '',
      profile_image: null,
      approval_delegatee: null,
    })),
    expenseReport: Factory.each(() => ({
      id: faker.random.number(),
      uuid: faker.random.uuid().replace(/-/g, ''),
      status: 1,
      createdDate: faker.date.past().toISOString(),
      has_sibling_items: false,
      notes: null,
    })),
    account: Factory.each(() => ApprovedExpenseItemAccountApiModelStub.build()),
  })
